import classNames from "classnames";
import React from "react";
import "./TableClasses.scss";

// Extend props
interface TableDataRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  children: React.ReactNode;
  className?: string;
}

const TableDataRow: React.FC<TableDataRowProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <tr className={classNames("table-data-row", className)} {...rest}>
      {children}
    </tr>
  );
};

export default TableDataRow;
